import { jwtDecode } from '@/vue/utils/appHelpers'
import ContactWriteMicroByCountryLastDigit from './ContactWriteMicroByCountryLastDigit'
interface Toggle {
  conditions: Array<{
    key: string
    version?: string[]
    operator: {
      name: string
      value: string
    }
  }>
}

const FEATURE_TOGGLES: Record<string, Toggle> = {
  ContactWriteMicroByCountryLastDigit,
}

function loadFeatureToggle(fileName: string): Toggle {
  try {
    const module = FEATURE_TOGGLES[fileName]
    return module
  } catch (error) {
    console.error(`Error al importar el archivo ${fileName}:`, error)
    throw error
  }
}

function validateToggle(toggleFileName: string): boolean {
  try {
    const toggle: Toggle = loadFeatureToggle(toggleFileName)
    const jwt = jwtDecode()

    const generalConditions = toggle.conditions.filter(condition => !condition.version)
    const versionSpecificConditions = toggle.conditions.filter(condition =>
      condition.version?.includes(jwt.applicationVersion)
    )

    const allConditions = [...generalConditions, ...versionSpecificConditions]

    const isToggleEnabled = allConditions.every(condition => {
      const conditionValue = jwt[condition.key]
      if (!conditionValue) return false

      switch (condition.operator.name) {
        case 'in-set':
          return condition.operator.value?.includes(conditionValue) ?? false
        case 'matches-regex': {
          const regex = new RegExp(condition.operator.value ?? '')
          return regex.test(conditionValue)
        }
        default:
          return false
      }
    })

    return isToggleEnabled
  } catch (error) {
    console.error(`Error validating feature toggle: ${toggleFileName}`, error)
    return false
  }
}

export { validateToggle }
